import { Link } from "react-router-dom";
import Logo from "./Logo";
import { NAV, SITE } from "@/data/content";

export default function Footer() {
  return (
    <footer className="bg-navy border-t border-white/10" data-testid="footer">
      <div className="container-luxe py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo dark />
          <p className="mt-5 text-white/55 text-sm leading-relaxed max-w-xs">
            A property consultancy helping buyers and investors explore opportunities in Dholera Smart City, Gujarat.
          </p>
        </div>

        <div>
          <h3 className="font-mono text-[11px] uppercase tracking-[0.24em] text-gold mb-5">Explore</h3>
          <ul className="space-y-3">
            {NAV.slice(1).map((n) => (
              <li key={n.href}>
                <a href={n.href} className="text-white/65 text-sm hover:text-gold transition-colors duration-300">{n.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-mono text-[11px] uppercase tracking-[0.24em] text-gold mb-5">Legal</h3>
          <ul className="space-y-3">
            <li><Link to="/privacy" data-testid="footer-link-privacy" className="text-white/65 text-sm hover:text-gold transition-colors duration-300">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-link-terms" className="text-white/65 text-sm hover:text-gold transition-colors duration-300">Terms &amp; Conditions</Link></li>
            <li><Link to="/disclaimer" data-testid="footer-link-disclaimer" className="text-white/65 text-sm hover:text-gold transition-colors duration-300">Disclaimer</Link></li>
            <li><a href="#contact" data-testid="footer-link-contact" className="text-white/65 text-sm hover:text-gold transition-colors duration-300">Contact Us</a></li>
          </ul>
        </div>

        <div>
          <h3 className="font-mono text-[11px] uppercase tracking-[0.24em] text-gold mb-5">Contact</h3>
          <ul className="space-y-3 text-sm text-white/65">
            <li>Paras Real Estate</li>
            <li>{SITE.location}</li>
            <li>Owner: {SITE.owner}</li>
            <li>
              <a href={SITE.phoneHref} data-testid="footer-phone-link" className="hover:text-gold transition-colors duration-300">Sunil Aggarwal: {SITE.phoneDisplay}</a>
            </li>
            <li>
              <a href={SITE.contact2.phoneHref} data-testid="footer-phone2-link" className="hover:text-gold transition-colors duration-300">{SITE.contact2.name}: {SITE.contact2.phoneDisplay}</a>
            </li>
            <li>
              <a href={`mailto:${SITE.email}`} data-testid="footer-email-link" className="hover:text-gold transition-colors duration-300 break-all">Email: {SITE.email}</a>
            </li>
            <li className="text-white/65">Business Hours: 10:00 AM – 8:00 PM</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-luxe py-6 flex flex-col md:flex-row gap-3 items-center justify-between">
          <p className="text-white/45 text-xs">© 2026 Paras Real Estate. All rights reserved.</p>
          <p className="text-white/35 text-xs text-center md:text-right max-w-xl">
            Information on this website is for general purposes only and is not financial or investment advice. Independently verify all property documents and approvals.
          </p>
        </div>
      </div>
    </footer>
  );
}
